import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (data.success) {
        setSubscribed(true);
        setEmail('');
      }
    } catch (err) {
      console.error('Newsletter error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (subscribed) {
    return (
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
        className="flex items-center gap-3 justify-center py-4">
        <CheckCircle className="w-5 h-5 text-primary" />
        <span className="text-primary font-medium">Te has suscrito correctamente</span>
      </motion.div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-text-muted" />
        <input type="email" required placeholder="Tu email" value={email}
          onChange={e => setEmail(e.target.value)}
          className="input-kinesthetic pl-10 !py-3" data-testid="newsletter-email" />
      </div>
      <button type="submit" disabled={submitting}
        className="btn-primary !py-3 flex-shrink-0" data-testid="newsletter-submit">
        {submitting ? 'Enviando...' : <><span>Suscribirme</span> <ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
};

export default Newsletter;
